/** @format */

export default {
  getSubscription: (state) => (id) => state.subscriptions.find((subscription) => subscription.id === id),
  getSubscriptions: (state) => () => state.subscriptions
}
